<script>
  import { createEventDispatcher } from "svelte";
  import MultiSelector from "../../Components/Common/MultiSelector.svelte";
  import { CalendarEventCategories } from "../../stores";
  import { CalendarEventCategoryTypes } from "../../Utils/utilEnums.svelte";
  import {
    loadCalendarEventCategories,
  } from "../../Utils/utilFunctions.svelte";

  export let value,
    disabled,
    borderClass = "select-bordered",
    emptyOptionName = "Select Category",
    showEmptyOption = true,
    heightClass,
    widthClass = "w-60";

  export let multiSelect = false;

  let allCategories = [],
    placeholder,
    isLoading = false;

  const dispatch = createEventDispatcher();

  const loadCats = async () => {
      loadCalendarEventCategories();
  };

  const filterCustomCategories = (allCats) => {
    if (allCats && allCats.length) {
      return allCats.filter(
        (cat) => cat.categoryType === CalendarEventCategoryTypes.Custom
      );
    } else return [];
  };

  $: allCategories = filterCustomCategories($CalendarEventCategories);

  $: selectedCatColor =
    allCategories?.find((cat) => cat.id === value)?.calendarColour ?? "#6f726c";
</script>

{#if multiSelect}
  <MultiSelector
    options={allCategories}
    isMulti={true}
    {disabled}
    bind:value
    {placeholder}
    isOptionsObj
    showColoredOptions
    colorKey="calendarColour"
    autoPosition={false}
    on:use={loadCats}
    on:change={() => dispatch("change")}
    displayBoxClass="select select-sm {borderClass} {widthClass} {heightClass}"
  />
{:else}
  <select
    class="select select-sm font-normal bg-transparent {borderClass} {widthClass} {heightClass}"
    bind:value
    {disabled}
    use:loadCats
    style="color: {selectedCatColor};"
    on:change={() => dispatch("change")}
  >
    {#if showEmptyOption}
      <option value={undefined} style="color: #6f726c;">
        {emptyOptionName}
      </option>
    {/if}
    {#each allCategories as option}
      <option
        value={option.id}
        selected={option.id === value}
        style="color: {option.calendarColour};"
      >
        {option.name}
      </option>
    {/each}
  </select>
{/if}

<style>
  .border-bottom {
    outline: 0;
    border-width: 0 0 2px;
    border-color: #818e9b;
    border-radius: 0;
  }
</style>
